// extracted by mini-css-extract-plugin
export default {"container":"SidingAccent_container__OKxUA","productListContainer":"SidingAccent_productListContainer__ITLRR","productGrid":"SidingAccent_productGrid__xg8P-"};